import { render, staticRenderFns } from "./CloudProvider.vue?vue&type=template&id=37c7d928&"
import script from "./CloudProvider.vue?vue&type=script&lang=js&"
export * from "./CloudProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c7d928')) {
      api.createRecord('37c7d928', component.options)
    } else {
      api.reload('37c7d928', component.options)
    }
    module.hot.accept("./CloudProvider.vue?vue&type=template&id=37c7d928&", function () {
      api.rerender('37c7d928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/CloudProvider.vue"
export default component.exports